import { type Enum } from '@webapp/infrastructure/types/Enum'

// Route `:status` param values for /bills/approvals/:status.
export const BillApprovalTabStatuses = {
  PENDING_APPROVAL: 'pending-approval', // Pending Approval tab (default) → GET /api/v3/ap/bills/
  APPROVAL_HISTORY: 'approval-history', // Approval History tab → GET /api/v2/ap/bill-statuses/?context=approval-history
} as const

export type BillApprovalTabStatus = Enum<typeof BillApprovalTabStatuses>
